import { ReactNode } from 'react';
import { useGetUser } from 'src/hooks';
import styles from './ContentPane.module.scss';
import classNames from 'classnames';
// import { useLocation } from 'react-router-dom';
// import { AppRoutes } from 'src/types';
// import { CustomZendeskLauncher } from 'src/v2/components/CustomZendeskLauncher';
import { CookieButton } from 'src/v2/components/LeftSidePanel/components/UserMenuSection/components/CookieButton';

type ContentPaneProps = {
  withRightSideBar?: boolean;
  children?: ReactNode;
};

export const ContentPane = ({
  withRightSideBar,
  children,
}: ContentPaneProps) => {
  // const { pathname } = useLocation();
  // const { isDesktopAndUp } = useBreakpoint();
  const { isOpenTier } = useGetUser();

  // const isPaymentPage = pathname === AppRoutes.PAYMENT;

  return (
    <div className={styles.root}>
      {isOpenTier && <CookieButton variant="fixed" />}

      <div
        className={classNames(styles.container, {
          [styles.reducedWidth]: withRightSideBar,
        })}
      >
        {children}
      </div>

      {/* {!isPaymentPage && isDesktopAndUp && withRightSideBar && (
        <CustomZendeskLauncher />
      )} */}
    </div>
  );
};
